import { defineRoute } from '../defineRoute';

export type LandlordPremiumRouteParams = {
  // ...
};

export type LandlordPremiumRouteParamsString = {
  // ...
};

export const LandlordPremium = defineRoute<
  LandlordPremiumRouteParams,
  LandlordPremiumRouteParamsString
>({
  pathname: '/tenant-search/payment-step1',
  nlPathname: '/huurder-zoeken/betaling-stap1',
  isLandlordRoute: true,
  routeParamsStringifier: () => {
    return {};
  },
  routeParamsParser: () => {
    return {};
  },
});
